<template>
  <div class="lwgl">

    <div style="width: 100%; display: flex; justify-content: space-around">
      <div style="width: 35%;  height: calc(100vh - 100px); background-color: #585858">
        <div style="width: 100%; display: flex; justify-content:center; margin-top: 10px">
          <div style="display: flex; justify-content: space-between">
            <!--<el-button type="primary">值传递</el-button>
            <el-button type="primary">引用传递</el-button>-->
          </div>
        </div>
        <div style="background-color: black; color: white; width: 90%;
        height: max-content; margin-top: 20px; margin-left: 5%">
          <div v-if="zhichuandi" style="line-height: 20px">
            <div style="display: flex; flex-direction: row; " v-for="item in zcdCode" :key="item.id">
              <div style="width: 30px; background-color: #585858">
                <span v-if="item.fk" style="font-weight: bolder; color: blue">
                  ==>
                </span>
                <span v-if="item.nk" style="font-weight: bolder; color: red; ">
                  ==>
                </span>
              </div>
              <div style="width: 20px; background-color: #585858; height: 20px">
                {{item.id === "" ? '' : item.id}}
              </div>
              <div :style="{textIndent: item.ml + 'em'}" style="margin-left: 10px">
                {{item.con}}
              </div>
            </div>
          </div>
        </div>
        <div style="width: 500px; display: flex; justify-content:center; margin-top: 10px; line-height: 10px">
          <div style="display: flex; justify-content: space-between; align-items: center">
            <el-button icon="el-icon-arrow-left" size="mini" @click="lastStep" v-if="step !== 1 && showStep">上一步</el-button>
            <span style="padding: 10px; color: white">第
              <span style="color: blue; font-weight: bolder">
                {{step}}
              </span>步</span>
            <el-button size="mini" @click="nextStep" v-if="step !== 11 && showStep">下一步<i class="el-icon-arrow-right el-icon--right"></i></el-button>
          </div>
        </div>
      </div>
      <div style="width: 60%; height: calc(100vh - 100px); background-color: #8c939d">
        <div style="width: 100%; height: 200px">
          <div style="border: solid 1px #585858">
            全局数据区
          </div>
          <div style="display: flex; justify-content: space-around; height: 500px; margin-top: 10px">
            <div style="width: 45%; border: solid 1px #585858; line-height: 30px">
              <span style="font-weight: bolder; ">栈</span>
              <div style="margin-top:10px; background-color: white; border-radius: 3px; padding: 5px; width: 80%; margin-left: 10%">
                <div style="text-align: left; padding-left: 5px">
                   [00d0s00sd]main
                </div>
                <div style="display: flex; justify-content: space-around; border: 1px dotted #585858">
                  <span>a</span>
                  <span>int</span>
                  <span>{{zcd.main.a}}</span>
                </div>
                <div style="display: flex; justify-content: space-around; border: 1px dotted #585858">
                  <span>b</span>
                  <span>int</span>
                  <span>{{zcd.main.b}}</span>
                </div>
              </div>
              <div style="background-color: white; margin-top: 10px;
              border-radius: 3px; padding: 5px; width: 80%; margin-left: 10%" v-if="zcd.swapShow">
                <div style="text-align: left; padding-left: 5px">
                   [00d0s00sd]swap(a,b)
                </div>
                <div style="display: flex; justify-content: space-around; border: 1px dotted #585858">
                  <span>a</span>
                  <span>int</span>
                  <span>{{zcd.swap.a}}</span>
                </div>
                <div style="display: flex; justify-content: space-around; border: 1px dotted #585858">
                  <span>b</span>
                  <span>int</span>
                  <span>{{zcd.swap.b}}</span>
                </div>
                <div style="display: flex; justify-content: space-around; border: 1px dotted #585858">
                  <span>t</span>
                  <span>int</span>
                  <span>{{zcd.swap.t}}</span>
                </div>
              </div>
            </div>
            <div style="width: 45%; border: solid 1px #585858; ">
              <span style="font-weight: bolder">堆</span>
            </div>
          </div>
        </div>
      </div>
    </div>



    <div>
      <el-dialog title="操作说明" :visible.sync="dialogFormVisible">
        <div style="text-align: left; padding: 30px; padding-top: 0px">

<p>1.左上角有三个实验按钮，点击相应按钮可以进行相应的实验</p>

<span>
  2.点击左侧代码框中的上一步按钮，可以返回上一步
</span>

<span>
  3.点击左侧代码框中的下一步按钮，可以逐行执行代码
</span>

<span>
  4.执行了关键步骤，对应的得分会在右上角的得分栏进行显示
</span>

<span>
  5.关键步骤：
</br>（1）开始执行函数；
  </br> （2）结束执行函数；
  </br> （3）退出实验。
</span>

<span>
  6.点击右上方的退出实验按钮，可以退出本次实验
</span>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">确 定</el-button>
        </div>
      </el-dialog>
    </div>


    <el-dialog title="请输入变量的值" :visible.sync="answerVisible" :close-on-press-escape="close" :close-on-click-modal="close">
      <el-input v-model="zcdAnswer.a" placeholder="请输入a的值"></el-input>
      <el-input v-model="zcdAnswer.b" placeholder="请输入b的值"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkAnswer">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="回答错误，正确答案如下" :visible.sync="answerInfoVisible" :close-on-press-escape="close" :close-on-click-modal="close">
      <div>
        a = 10
      </div>
      <div>
        b = 5
      </div>
      <div>
        您当前得分: {{nowScore}}分
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="answerInfoVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="回答正确，您当前得分为" :visible.sync="answerInfoSuccessVisible" :close-on-press-escape="close" :close-on-click-modal="close">
      <div>
        {{nowScore}}分
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="answerInfoSuccessVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>


</template>

<script>
  import {
    qryPaperList,
    uploadImgUrl,
    uploadPdfUrl,
    qryPaperTypeList,
    updatePaperInfo,
    delPaperInfo,
    authToken
  } from '../../request/api';

  export default {
    data() {
      return {
        dialogFormVisible: false,
        step: 1,
        zhichuandi: true,
        zcdCode: [
          {id:1,ml:0,con:"#!/usr/bin/python",a:"?",b:"?",fk: false, nk: false},
          {id:2,ml:0,con:"# -*- coding: UTF-8 -*-",a:"?",b:"?",fk: false, nk: false},
          {id:3,ml:0,con:"",a:"?",b:"?",fk: false, nk: false},
          {id:4,ml:0,con:"",a:"?",b:"?",fk: false, nk: false},
          {id:5,ml:0,con:"a = 10",a:"?",b:"?",fk: false, nk: true},
          {id:6,ml:0,con:"b = 5",a:"?",b:"?",fk: false, nk: false},
          {id:7,ml:0,con:"def swap(a, b):",a:"?",b:"?",fk: false, nk: false},
          {id:8,ml:2,con:"t = a",a:"?",b:"?",fk: false, nk: false},
          {id:9,ml:2,con:"a = b",a:"?",b:"?",fk: false, nk: false},
          {id:10,ml:2,con:"b = t",a:"?",b:"?",fk: false, nk: false},
          {id:11,ml:0,con:"",a:"?",b:"?",fk: false, nk: false},
          {id:12,ml:0,con:"",a:"?",b:"?",fk: false, nk: false},
          {id:13,ml:0,con:"swap(a, b)",a:"?",b:"?",fk: false, nk: false},
          {id:14,ml:0,con:"print(\"a = \"+ str(a) +\", b = \" + str(b))",a:"?",b:"?",fk: false, nk: false},
          {id:"",ml:0,con:"",a:"?",b:"?",fk: false, nk: false},
          {id:"",ml:0,con:"",a:"?",b:"?",fk: false, nk: false},
          {id:"",ml:0,con:"",a:"?",b:"?",fk: false, nk: false},
          {id:"",ml:0,con:"",a:"?",b:"?",fk: false, nk: false},
          {id:"",ml:0,con:"",a:"?",b:"?",fk: false, nk: false},
        ],
        zcd: {
          main: {
            a: '?',
            b: '?',
          },
          swap: {
            a: '?',
            b: '?',
            t: '?',
          },
          swapShow: false,
        },
        answerVisible: false,
        answerInfoVisible: false,
        answerInfoSuccessVisible: false,
        zcdAnswer: {
          a: '',
          b: ''
        },
        showStep: true,
        nowScore: 0,
        close: false
      };
    },
    methods: {
      nextStep() {
        if (this.zhichuandi) {
          // 步骤增加1
          this.step++;
          this.zcdStepCon();
        }
      },
      lastStep() {
        if (this.zhichuandi) {
          // 步骤增加1
          this.step--;
          this.zcdStepCon();
        }
      },
      checkAnswer() {
        if (this.zcdAnswer.a !== '10' && this.zcdAnswer.a !== '5') {
          this.answerVisible = false;
          this.answerInfoVisible = true;
        } else {
          this.answerVisible = false;
          this.answerInfoSuccessVisible = true;
          this.nowScore = 20
        }
      },
      zcdStepCon() {
        if (this.step === 1) {
          // 第二步
          this.zcdCode.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode[4].nk = true;

          this.zcd.main.a = "?";
          this.zcd.main.b = "?";
          this.zcd.swapShow = false
        } else if (this.step === 2) {
          // 第二步
          this.zcdCode.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode[4].fk = true;
          this.zcdCode[5].nk = true;

          this.zcd.main.a = 10;
          this.zcd.main.b = "?";
          this.zcd.swapShow = false
        } else if (this.step === 3) {
          // 第三步
          this.zcdCode.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode[5].fk = true;
          this.zcdCode[12].nk = true;
          this.zcd.main.a = 10;
          this.zcd.main.b = 5;
          this.zcd.swapShow = false
        } else if (this.step === 4) {
          // 第四步
          this.zcdCode.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode[12].fk = true;
          this.zcdCode[6].nk = true;
          this.zcd.main.a = 10;
          this.zcd.main.b = 5;

          this.zcd.swapShow = true
        } else if (this.step === 5) {
          // 第五步
          this.zcdCode.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode[6].fk = true;
          this.zcdCode[7].nk = true;
          this.zcd.swap.a = 10;
          this.zcd.swap.b = 5;
          this.zcd.swap.t = '?';
          this.zcd.swapShow = true
        } else if (this.step === 6) {
          // 第六步
          this.zcdCode.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode[7].fk = true;
          this.zcdCode[8].nk = true;
          this.zcd.swap.a = 10;
          this.zcd.swap.b = 5;
          this.zcd.swap.t = 10;
          this.zcd.swapShow = true
        } else if (this.step === 7) {
          // 第七步
          this.zcdCode.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode[8].fk = true;
          this.zcdCode[9].nk = true;
          this.zcd.swap.a = 5;
          this.zcd.swap.b = 5;
          this.zcd.swap.t = 10;
          this.zcd.swapShow = true
        } else if (this.step === 8) {
          // 第八步
          this.zcdCode.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode[9].nk = true;
          this.zcd.swap.a = 5;
          this.zcd.swap.b = 10;
          this.zcd.swap.t = 10;
          this.zcd.swapShow = true
        } else if (this.step === 9) {
          // 第九步
          this.zcdCode.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode[12].fk = true;
          this.zcdCode[13].nk = true;
          this.zcd.swapShow = false

          this.zcd.main.a = 10;
          this.zcd.main.b = 5;
        } else if (this.step === 10) {
          // 第十步
          this.zcdCode.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcdCode[13].nk = true;
          this.zcd.swapShow = false

          this.zcd.main.a = 10;
          this.zcd.main.b = 5;
        } else if (this.step === 11) {
          // 第十一步
          this.zcdCode.forEach(item => {
            item.fk = false;
            item.nk = false;
          });
          this.zcd.swapShow = false

          this.zcd.main.a = 10;
          this.zcd.main.b = 5;

          this.answerVisible = true

          this.nowScore = 10
          this.showStep  = false;
        }

      }
    },
    mounted() {

    },
    props: ["itemData"]
  };
</script>

<style lang="less">
  .lwgl {
    background-color: #EFF3FF;
    padding: 20px;
    height: calc(100vh - 216px);
  }

  .el-table th.el-table__cell {
    background-color: #EFF3FF;
  }

  .searchClass {
    width: 900px;
    height: 70px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .avatar-uploader {
    text-align: left;
  }

  .upload-demo {
    text-align: left;
  }

  .lwgl .el-table .el-table__body-wrapper {
    height: calc(100vh - 455px);
    min-height: 250px;
    overflow-y: auto;
  }

  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
  }

  .el-select {
    width: 100%;
  }

  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
    padding-left: 10px;
    padding-right: 10px;
  }

  .searchClass .el-form--inline .el-form-item__content {
    margin-top: 13px;
  }

</style>




// WEBPACK FOOTER //
// src/components/lw/lwgl.vue